import {gql} from '@apollo/client';

export default gql`
  query getCampaignDownloadLocations($organizationId: ID!, $id: ID!) {
    me {
      id
      organization(id: $organizationId) {
        id
        campaign(id: $id) {
          id
          downloads {
            locations {
              count
              nodes(limit: 2000) {
                country
                region
                city
                latitude
                longitude
                total
              }
              countries(limit: 200) {
                country
                total
              }
            }
          }
        }
      }
    }
  }
`;
